export const HIGHLIGHT_PRODUCT_LIMIT = 2;
export const PRODUCTS_LOAD_MORE_COUNT = 6;
export const HOVER_ZOOM_CONSTANTS = {
    LENS_SIZE: 120,
    ZOOM_FACTOR: 4,
    ZOOM_OFFSET: 24,
};
